import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-host Inter (the font Axiom v3 + Prism both use). Without this the v3
// tokens fall back to system-ui and don't match Prism. Weights match what the
// v3 Text/Heading scale uses (400 body, 500/600 headings, 700, 900 display).
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/inter/latin-900.css';
import './styles/colors.css';
import './styles/global.css';
import { Providers } from './app/providers';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers />
  </React.StrictMode>,
);
